import { isDefined } from "@ls/js-utils";
import scope from "state/analytics/scope";
import CalcType from "state/Constants/CalcType";
import ScaleType from "state/Constants/ScaleType";

export default class BookAnalyticDefinition {
  #bookAnalytic;
  #basis;
  #calcType;
  #scaleType;

  constructor(props = {}) {
    const { bookAnalytic, basis, calcType, scaleType } = props;
    this.#bookAnalytic = bookAnalytic;
    this.#basis = basis;
    this.#calcType = calcType;
    this.#scaleType = scaleType;
  }

  get bookAnalytic() {
    return this.#bookAnalytic;
  }

  get basis() {
    return this.#basis;
  }

  get calcType() {
    return this.#calcType;
  }

  get scaleType() {
    return this.#scaleType;
  }

  get key() {
    return `${scope} - ${this.#bookAnalytic}, ${this.#calcType}, ${this.#basis}, ${this.#scaleType}`;
  }

  get complete() {
    return (
      isDefined(this.#bookAnalytic) &&
      isDefined(this.#basis) &&
      isDefined(this.#calcType) &&
      isDefined(this.#scaleType)
    );
  }

  static getDefault = () =>
    new BookAnalyticDefinition({
      bookAnalytic: "amortBookGSpread",
      calcType: CalcType.Account,
      basis: "gaap",
      scaleType: ScaleType.Contribution,
    });
  copy = () => ({
    bookAnalytic: this.#bookAnalytic,
    calcType: this.#calcType,
    basis: this.#basis,
    scaleType: this.#scaleType,
  });
  setBookAnalytic = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      bookAnalytic: value,
    });
  setCalcType = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      calcType: value,
    });
  setBasis = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      basis: value,
    });
  setScaleType = (value) =>
    new BookAnalyticDefinition({
      ...this.copy(),
      scaleType: value,
    });
}
